import React, { useState } from 'react'
import { useRouter } from 'next/router'
import NextLink from 'next/link'
import { SearchIcon } from '@chakra-ui/icons'
import {
  Box,
  Flex,
  HStack,
  Link,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react'

const articlesCategories = [
  'beginner',
  'advanced',
  'institutional',
  'research',
  'downloads',
]
const articlesTypes = [
  {
    name: 'Articles',
    link: '/education/tag/article',
    isExternal: false,
  },
  {
    name: 'Videos',
    link: 'https://www.youtube.com/@CompassMining',
    isExternal: true,
  },
  {
    name: 'Podcasts',
    link: '/education/tag/podcast',
    isExternal: false,
  },
]

export const TagsHeader = () => {
  const router = useRouter()
  const [searchTerm, setSearchTerm] = useState('')

  const handleSearch = () => {
    const trimmed = searchTerm.trim()
    if (!trimmed) return
    router.push({
      pathname: '/education/search',
      query: { filter: trimmed },
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSearch()
    }
  }

  return (
    <Flex
      flexDirection={{ base: 'column', lg: 'row' }}
      justifyContent={'space-between'}
      flexWrap="wrap"
      gap={4}
    >
      <HStack
        gap={4}
        overflowX="auto"
        flexWrap={{ base: 'unset', md: 'wrap' }}
        maxW="full"
      >
        <HStack gap={{ base: 4, lg: 6, xl: 8 }}>
          {articlesCategories.map((article: string, index) => (
            <Link
              key={`category-${index}`}
              display="block"
              px={4}
              py={2}
              borderWidth={1}
              borderColor="whiteAlpha.500"
              rounded="xl"
              lineHeight="normal"
              textTransform="capitalize"
              color="white"
              _hover={{ color: 'black', backgroundColor: 'white' }}
              onClick={() => {
                const section = document.getElementById(article)
                if (section) {
                  section.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
              }}
            >
              {article}
            </Link>
          ))}
        </HStack>
        <Box color="white" px={{ base: 0, lg: 2, xl: 4 }}>
          |
        </Box>
        <HStack gap={{ base: 4, lg: 6, xl: 8 }}>
          {articlesTypes.map((type, index) => (
            <NextLink passHref href={type.link} key={`type-${index}`}>
              <Link
                isExternal={type.isExternal}
                color="white"
                textDecoration="underline"
                _hover={{ color: 'brand.600' }}
              >
                {type.name}
              </Link>
            </NextLink>
          ))}
        </HStack>
      </HStack>
      <InputGroup
        maxW={{ base: 'full', lg: '400px', xl: '222px' }}
        borderColor="gray.200"
        rounded="lg"
      >
        <InputLeftElement cursor="pointer" onClick={handleSearch}>
          <SearchIcon color="white" fontSize="14px" />
        </InputLeftElement>
        <Input
          fontSize="14px"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          color="white"
          _placeholder={{
            color: 'whiteAlpha.500',
          }}
        />
      </InputGroup>
    </Flex>
  )
}
